export default "__VITE_PUBLIC_ASSET__837c2002__"